import "./article-page.scss";

import cn from "clsx";
import {
  BaseLayout,
  SiteHeaderComponent,
} from "design-system/components/layouts/base";
import { BreadcrumbsProps } from "design-system/components/primitives/breadcrumbs/breadcrumbs";
import { ArticleBody, ArticleBodyProps } from "./article-body/article-body";
import { ArticleFooterProps } from "design-system/components/pages/article-page/article-footer/article-footer";
import { SiteFooterProps } from "design-system/components/universal/site-footer/site-footer";
import { ExtractLazyComponent } from "design-system/components/system/lazy-component/lazy-component";
import { ReactNode } from "react";
import { SimpleTheme } from "design-system/utils/theme";

export type ArticlePageTopper = ExtractLazyComponent<
  "SplitTopper" | "ArticleTopper" | "ParticipantStoryTopper"
>;

export interface ArticlePageProps {
  topper?: ArticlePageTopper;
  breadcrumbs?: BreadcrumbsProps;
  body?: ArticleBodyProps;
  footer?: ArticleFooterProps;
  siteHeader?: SiteHeaderComponent;
  siteFooter?: SiteFooterProps;
  children?: ReactNode;
  theme?: SimpleTheme;
  useDropCap?: boolean;
  preFooterContent?: ReactNode;
}

export function ArticlePage({
  body,
  breadcrumbs,
  footer,
  siteFooter,
  siteHeader,
  topper,
  children,
  preFooterContent,
  theme,
  useDropCap,
}: ArticlePageProps) {
  return (
    <BaseLayout
      footer={siteFooter}
      header={siteHeader}
      className={cn(
        "hbs-page",
        "hbs-article-page",
        topper?.name && `hbs-page--${topper.name}`,
      )}
    >
      {body && (
        <ArticleBody
          breadcrumbs={breadcrumbs}
          topper={topper}
          footer={footer}
          preFooterContent={preFooterContent}
          useDropCap={useDropCap}
          theme={theme}
          {...body}
        />
      )}
      {children}
    </BaseLayout>
  );
}
